export const FISHING_BRAND_CATEGORIES = [
    { slug: 'canas-carretes-aparejos', label: 'Cañas, carretes y aparejos' },
    { slug: 'senuelos-cebos', label: 'Señuelos y cebos' },
    { slug: 'electronica-embarcaciones', label: 'Electrónica y embarcaciones' },
    { slug: 'ropa-equipo', label: 'Ropa, calzado y equipo personal' },
] as const;

export const FISHING_BRAND_STATUSES = [
    { value: 'publicada', label: 'Publicada' },
    { value: 'borrador', label: 'Borrador' },
    { value: 'revisar', label: 'Revisar' },
] as const;

export type FishingBrandStatus = (typeof FISHING_BRAND_STATUSES)[number]['value'];

export type FishingBrandSubmissionSource = 'admin' | 'club_manual' | 'import';

export interface FishingBrandListRow {
    id: string;
    slug: string;
    name: string;
    country_iso: string;
    country_name: string;
    category: string;
    category_slug: string;
    website_url: string | null;
    logo_url: string | null;
    logo_background: 'claro' | 'oscuro';
    status: FishingBrandStatus;
    content_generated: boolean;
    is_active: boolean;
    store_brand_count: number | string;
    club_sponsor_count: number | string;
    total_count: number | string;
    created_at: string;
    updated_at: string;
    submission_source?: FishingBrandSubmissionSource | string;
}

export interface FishingBrandDetail extends FishingBrandListRow {
    logo_source_url: string | null;
    short_description: string | null;
    long_description: string | null;
    internal_notes: string | null;
    sort_order: number;
}
